import { Controller, useFormContext } from "react-hook-form";
import { z } from "zod";

import { Switch } from "@/components/ui/switch";
import { useConfig } from "@/lib/config";
import { SettingsGroupForm } from "./SettingsGroup";

const schema = z.object({
  allowSelfValidation: z.string().nullish(),
  hideTestEnvironmentBadge: z.string().nullish(),
});
type FormValues = z.infer<typeof schema>;

export function TestEnvSettings() {
  const { testEnv } = useConfig();

  if (!testEnv) {
    return null;
  }

  return (
    <SettingsGroupForm title="Test environment settings" schema={schema}>
      <FormFields />
    </SettingsGroupForm>
  );
}

function FormFields() {
  const { control } = useFormContext<FormValues>();
  return (
    <div className="flex flex-col gap-2">
      <Controller
        control={control}
        name="allowSelfValidation"
        render={({ field }) => (
          <Switch
            isSelected={field.value === "true"}
            onChange={(val) => field.onChange(val.toString())}
          >
            Allow results to be self-validated
          </Switch>
        )}
      />
      <Controller
        control={control}
        name="hideTestEnvironmentBadge"
        render={({ field }) => (
          <Switch
            isSelected={field.value === "true"}
            onChange={(val) => field.onChange(val.toString())}
          >
            Hide test environment badge
          </Switch>
        )}
      />
    </div>
  );
}
